import type { MetaWatchlistDefinition } from '../models/definition.types'
import type { MetaWatchlistDraft, WatchlistFormField } from '../models/watchlist.types'
import { buildPayload } from '../service/metaWatchlist'

export type SaveMetaWatchlistOutcome =
  | { status: 'invalid'; errors: ReturnType<typeof buildPayload>['errors'] }
  | { status: 'failed' }
  | { status: 'saved'; definitions: MetaWatchlistDefinition[] }

export interface MetaAttributeWriter {
  save: (value: MetaWatchlistDefinition[] | null) => Promise<unknown | null>
}

export class SaveMetaWatchlistFlow {
  constructor(private readonly attribute: MetaAttributeWriter) {}

  async execute(
    drafts: readonly MetaWatchlistDraft[],
    fields: readonly WatchlistFormField[],
  ): Promise<SaveMetaWatchlistOutcome> {
    const result = buildPayload(drafts, fields)
    if (Object.keys(result.errors).length) return { status: 'invalid', errors: result.errors }
    const saved = await this.attribute.save(result.payload.length ? result.payload : null)
    return saved === null ? { status: 'failed' } : { status: 'saved', definitions: result.payload }
  }
}
